<mat-card class="large-card">
    <div class="padding-24">
        <div class="settings-heading">System Users</div>

        <p class="section-title" style="font-size: 14px">
            Internal users assigned to the SimpleNexus client. Users marked as enabled have the
            ability to log in. Users set to Platform User act as global power users. They have the
            ability to change clients, impersonate, and have access to all client data. Super Users
            have the ability to change the settings of the client.
        </p>

        <div class="system-user-button-area">
            <div class="system-user-search-box-area">
                <mat-form-field fluid appearance="outline" class="example-full-width">
                    <mat-label>Find Email</mat-label>
                    <input
                        matInput
                        [(ngModel)]="searchTerms"
                        class="search-field"
                        (ngModelChange)="emailSearch()"
                        [ngModelOptions]="{ standalone: true }"
                    />
                    <mat-icon matSuffix>search</mat-icon>
                </mat-form-field>
            </div>
            <div>
                <div
                    class="toggle-button-area"
                    style="float: left; padding-right: 16px; padding-top: 5px"
                    *ngIf="lbaUsers"
                >
                    <label class="toggle-label">Enabled&nbsp;&nbsp;</label>
                    <kendo-switch
                        [checked]="showEnabled"
                        [(ngModel)]="checked"
                        (click)="changeEnabled($event)"
                        [ngClass]="checked ? 'kendo-switch-on' : 'kendo-switch-off'"
                    >
                    </kendo-switch>
                </div>
                <button
                    type="button"
                    mat-raised-button
                    class="mat-raised-button-new-user"
                    (click)="newUser()"
                >
                    <i class="fal fa-plus-square"></i>
                    &nbsp; ADD SYSTEM USER
                </button>
            </div>
            <div class="system-user-export-button">
                <button
                    type="button"
                    mat-raised-button
                    (click)="exportToExcel('house-system-users')"
                >
                    <mat-icon fontSet="far" fontIcon="fa-file-excel"></mat-icon>
                    System Users
                </button>
            </div>
            <div class="system-user-export-button">
                <button
                    type="button"
                    mat-raised-button
                    (click)="exportToExcel('clients-power-users')"
                >
                    <mat-icon fontSet="far" fontIcon="fa-file-excel"></mat-icon>
                    Power users
                </button>
            </div>
        </div>
        <table class="admin-table">
            <thead>
                <tr>
                    <th>Email</th>
                    <th>User Type</th>
                    <th>Enabled</th>
                    <th>Password</th>
                </tr>
            </thead>
            <tbody>
                <ng-container
                    *ngIf="
                        searchTerms?.length === 0 ||
                            (lbaUsersDisplay && lbaUsersDisplay.length > 0);
                        else noUserFound
                    "
                >
                    <tr *ngFor="let user of lbaUsersDisplay">
                        <td>
                            {{ user.loginEmail }}
                        </td>
                        <td>
                            <mat-form-field
                                fluid
                                appearance="outline"
                                class="emailinpu-form-field"
                                style="width: 250px"
                            >
                                <mat-select
                                    [(ngModel)]="user.userType"
                                    [disabled]="!user.isActive"
                                    (selectionChange)="updateUser(user)"
                                >
                                    <mat-option
                                        *ngFor="
                                            let userType of [
                                                { type: 'None', key: 0 },
                                                { type: 'Demo User', key: 3 },
                                                { type: 'Platform User', key: 1 },
                                                { type: 'Super User', key: 2 }
                                            ]
                                        "
                                        [value]="userType.key"
                                    >
                                        {{ userType.type }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </td>

                        <td>
                            <input
                                type="checkbox"
                                [(ngModel)]="user.isActive"
                                (change)="updateUser(user)"
                            />
                        </td>
                        <td>
                            <button
                                mat-stroked-button
                                (click)="resetPassword(user)"
                                *ngIf="!user.newPassword"
                            >
                                Reset
                            </button>
                            <span *ngIf="user.newPassword"
                                ><b>{{ user.newPassword }}</b></span
                            >
                        </td>
                    </tr>
                </ng-container>
                <ng-template #noUserFound>
                    <tr>
                        <td colspan="4" style="text-align: center; opacity: 0.8">
                            System User Not Found
                        </td>
                    </tr>
                </ng-template>
            </tbody>
        </table>

        <!-- ADD NEW USER MENU -->

        <div id="admin-background" *ngIf="addMenuOpen">
            <div id="admin-menu">
                <div id="admin-menu-header">
                    <span>ADD SYSTEM USER</span>
                    <span (click)="addMenuOpen = false" class="float-right">
                        <i class="fas fa-times"></i>
                    </span>
                </div>

                <br />
                <div class="admin-menu-body">
                    <div>Email:</div>
                    <div>
                        <mat-form-field fluid appearance="outline" class="emailinpu-form-field">
                            <input
                                [(ngModel)]="newUserModel.loginEmail"
                                class="text-field"
                                type="text"
                                maxlength="120"
                                matInput
                            />
                        </mat-form-field>
                    </div>
                    <span *ngIf="errorMessage" style="color: red; font-size: 12px">{{
                        errorMessage
                    }}</span>

                    <br />

                    <div>User Type:</div>
                    <div>
                        <mat-form-field fluid appearance="outline" class="emailinpu-form-field">
                            <mat-select [(ngModel)]="newUserModel.userType">
                                <mat-option
                                    *ngFor="
                                        let userType of [
                                            { type: 'None', key: 0 },
                                            { type: 'Demo User', key: 3 },
                                            { type: 'Platform User', key: 1 },
                                            { type: 'Super User', key: 2 }
                                        ]
                                    "
                                    [value]="userType.key"
                                >
                                    {{ userType.type }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>

                    <br />
                    <br />

                    <label>Is Active:</label>
                    <input type="checkbox" [(ngModel)]="newUserModel.isActive" />
                </div>

                <br />
                <div width="150px" style="float: right; padding-top: 20px">
                    <button mat-button (click)="addMenuOpen = false">Cancel</button>
                    &nbsp;&nbsp;
                    <button mat-button primary (click)="saveUser()" [disabled]="saveDisabled()">
                        Save
                    </button>
                </div>

                <br /><br /><br />

                <div class="admin-menu-body" *ngIf="userAdded">
                    <p>
                        User account has been created for <b>{{ userEmail }}</b
                        >. Copy the password below:
                    </p>
                    <p>
                        <b>{{ userPassword }}</b>
                    </p>
                </div>
            </div>
        </div>
    </div>
</mat-card>
